import React from "react";
import CustomLoader from "@/components/global/CustomLoader";

const LazyLoading = ({ parentClassName }) => {
  return (
    <div className={`flex items-center justify-center ${parentClassName}`}>
      <CustomLoader
        className="h-auto w-12 sm:w-16"
        fallback={
          <span className="size-4 sm:size-8  animate-spin rounded-full border-r border-t border-black" />
        }
      />
    </div>
  );
};

export default LazyLoading;
